export default {
  statisticsWs: null,
  totalPlayCount: 0,
  totalWinCount: 0,
  totalWinVolume: 0,
  totalReferralCount: 0,
  totalReferralVolume: 0
}
